import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
import { SessionEventArgs } from "./Exports";
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */

export var ConnectionEventArgs = /*#__PURE__*/function (_SessionEventArgs) {
  _inherits(ConnectionEventArgs, _SessionEventArgs);

  function ConnectionEventArgs() {
    _classCallCheck(this, ConnectionEventArgs);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConnectionEventArgs).apply(this, arguments));
  }

  return ConnectionEventArgs;
}(SessionEventArgs);